/*
 * @format
 */

export const AUTO_MODE = 'Auto';
export const MANUAL_MODE = 'Manual';
export const ON_MODE = 'On';
export const OFF_MODE = 'Off';
export const OVERRIDE_NEXT_MODE = 'OverrideNext';
export const OVERRIDE_PLUS_HOURS_MODE = 'OverridePlus';
export const DSR_ACTIVE = 'DSRActive';
// Holiday is a distinct axis from the heating mode (the device reports it as
// holidayMode === 3), NOT a commandable heating mode. It is deliberately a
// STANDALONE constant, kept OUT of the MODES set below, so nothing that iterates
// MODES (mode buttons, the mode action panel) ever treats it as a heating mode.
// It exists only so the desired-state layer can recognise a legacy holiday goal
// that still arrives on the wire as mode 'Holiday'.
export const HOLIDAY_MODE = 'Holiday';

export const MAX_SETPOINT = 3000;

export const HALO_AIR_MAX_OPTIMISATION_HRS = 6;

export const MODES = {
  Auto: AUTO_MODE,
  Manual: MANUAL_MODE,
  On: ON_MODE,
  Off: OFF_MODE,
  OverrideNext: OVERRIDE_NEXT_MODE,
  OverridePlusHours: OVERRIDE_PLUS_HOURS_MODE,
  DSRActive: DSR_ACTIVE,
};

export const DAYS_OF_WEEK = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
};

export const COGNITO_EMAIL = 'no-reply@idealhalo.co.uk';

export const isValidMode = mode =>
  mode === MODES.Auto ||
  mode === MODES.Manual ||
  mode === MODES.Off ||
  mode === MODES.OverrideNext ||
  mode === MODES.OverridePlusHours;

export const MINUTES_SINCE_SUNDAY = {
  Sunday: 0,
  Monday: 1440,
  Tuesday: 2880,
  Wednesday: 4320,
  Thursday: 5760,
  Friday: 7200,
  Saturday: 8640,
};

export const DEVICE_TYPES = {
  Boiler: 'Boiler',
  Si: 'Smart Interface',
  Prt: 'Halo',
  ZigbeeRepeater: 'Zigbee Booster',
  Swc: 'Smart Wiring Centre',
};

export const PRT_SETTINGS = {
  optimisedStartEnabled: 'optimisedStartEnabled',
  optimisedStopEndabled: 'optimisedStopEndabled',
  delayedStartEnabled: 'delayedStartEnabled',
  childLockOn: 'childLockOn',
  displayTolerance: 'displayToleranceDot1',
  temperatureOffset: 'temperatureOffset',
  timeFormat: 'timeFormat',
  frostProtectionSetpoint: 'frostProtectionSetpoint',
};

export const IDEAL_SUPPORT_NUMBER = '01482498660';

export const CURRENT_TERMS_VERSION = 1;
export const TERMS_AND_CONDITIONS_LINK =
  'https://idealheating.com/link-app-terms-conditions';
export const IDEAL_HEATING_SUPPORT_NUMBER = '01482 498660';
export const IDEAL_HEATING_BETA_EMAIL = 'halo.beta.test@groupe-atlantic.co.uk';

export const SIMPLE_SCHEDULE_INFO_TEXT = [
  [
    'Simple schedule',
    "Using Geolocation removes the need for complicated schedules, instead you set your desired temperatures for when you're at home. To ensure optimum comfort you can set 3 different temperatures to cover; the main part of the day, the evening, and over night.\n\nYou select the time you want each period to start and what temperature you want for that period.\n\nIf you leave the property at any point Geolocation will automatically turn your heating to Frost Protection to save energy. When you return it will set your heating to temperature of the correct period.\n\nThe temperatures you select are limited by your Frost protection setting and the Maximum heating setting. If you have a 2-Zone system the highest Frost protection setting and the lowest Maximum heating setting, from both zones, will be used.",
  ],
];
